import type { PropsWithChildren } from "react";
import { Button } from "../button";
import { Calendar } from "../calendar";
import type { CalendarControls } from "../calendar/use-calendar-controls";
import { Icon } from "../icons";
import { Menu, type MenuItems } from "../menu";
import { type QueryKey, useQueryClient } from "../query";

/** Props Interface */
interface DashboardTileControlsProps extends PropsWithChildren {
	calendarControls?: CalendarControls;
	onAdd?: () => void;
	queryKey: QueryKey;
	menuItems?: MenuItems;
}

export function DashboardTileControls({
	calendarControls,
	onAdd,
	queryKey,
	children,
	menuItems,
}: DashboardTileControlsProps) {
	/** Hooks */
	const qc = useQueryClient();

	const isLoading = qc.isFetching({ queryKey }) > 0;

	/** Functions */
	async function handleOnRefetch() {
		await qc.refetchQueries({ queryKey });
	}

	/** Render */
	return (
		<div className="h-stack flex-1 justify-end">
			{children}
			{onAdd && (
				<Button
					icon={<Icon name="Plus" />}
					onClick={onAdd}
					size="xxs"
				/>
			)}
			{calendarControls && (
				<Calendar.Controls
					buttonProps={{
						size: "xxs",
					}}
					onBack={calendarControls.handleOnGoBack}
					onForward={calendarControls.handleOnGoForward}
				/>
			)}
			<Button
				icon={<Icon name="RefreshCcw" />}
				onClick={handleOnRefetch}
				size="xxs"
				isLoading={isLoading}
			/>
			{menuItems && (
				<Menu items={() => menuItems}>
					<Button
						icon={<Icon name="EllipsisVertical" />}
						size="xxs"
					/>
				</Menu>
			)}
		</div>
	);
}
